import React, { useState, FC } from 'react';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useIntl } from 'react-intl';
import { GlobalFormContactBody } from 'src/modules/global';
import styles from './PagesContactForm.module.scss';
import formStyles from '../../../global/components/forms/contact/GlobalFormContact.module.scss';
import { useLocale, OutputChannels } from 'src/modules/locale';

interface PagesContactFormProps {
  showHeaderAndFooter?: boolean;
}

const PagesContactForm: React.FunctionComponent<PagesContactFormProps> = ({
  showHeaderAndFooter = true,
}) => {
  const data = {
    oid: '00D3X000002KGzs',
    '00N3X00000Lx0Xn': 'Unknown',
    lead_source: 'Website',
    recordType: '0123X000001A3q3QAC',
    retURL: (typeof window !== 'undefined' && window.location.href) || 'http://walterknoll.de',
  };

  const intl = useIntl();
  const [submitSucess, setSubmitSucess] = useState(false);
  const { outputChannel } = useLocale();

  const pageProperties = {
    title: `${intl.formatMessage({ id: 'page/contactForm/title' })} | ${
      outputChannel === OutputChannels.US ? 'Walter K.' : 'Walter Knoll'
    }`,
    description: '',
    showBreadcrumbs: false,
    topElement: null,
    noIndex: true,
  };

  const onSubmit = (success: boolean) => {
    setSubmitSucess(success);
  };

  if (submitSucess) {
    pageProperties.topElement = (
      <div className={styles.success}>{intl.formatMessage({ id: 'form/confirmationSubline' })}</div>
    );
  }

  const Wrapper: FC = ({ children }) => {
    if (showHeaderAndFooter) return <LayoutPage {...pageProperties}>{children}</LayoutPage>;

    return (
      <div>
        <div className={styles.noHeaderFooterErrorContainer}>{pageProperties.topElement}</div>
        <div className={styles.noHeaderFooterContainer}>{children}</div>
      </div>
    );
  };

  return (
    <Wrapper>
      <div className={formStyles.container}>
        <GlobalFormContactBody
          url={process.env.NEXT_PUBLIC_SALESFORCE_FORM_URL}
          data={data}
          title={intl.formatMessage({ id: 'page/contactForm/title' })}
          onSubmit={onSubmit}
        />
      </div>
    </Wrapper>
  );
};

export default PagesContactForm;
